export default __webpack_public_path__ + "static/media/Connecticut6Open.31505378.jpg";